import produce from 'immer';

const INITIAL_STATE = {
  list: [],
  registry: {},
  loading: false,
  saving: false,
  error: false,
  page: 1,
  count: 0,
};

export default function taskHistory(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@taskHistory/INDEX_REQUEST':
    case '@taskHistory/DELETE_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.error = false;
      });

    case '@taskHistory/CREATE_REQUEST':
    case '@taskHistory/UPDATE_REQUEST':
      return produce(state, draft => {
        draft.saving = true;
        draft.error = false;
      });

    case '@taskHistory/READ_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.error = false;
      });

    case '@taskHistory/CREATE_SUCCESS':
    case '@taskHistory/UPDATE_SUCCESS':
    case '@taskHistory/DELETE_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.saving = false;
      });

    case '@taskHistory/INDEX_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.list = action.payload.data;
        draft.page = action.payload.page;
        draft.count = action.payload.count;
      });

    case '@taskHistory/READ_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = false;
        draft.registry = action.payload.data;
      });

    case '@taskHistory/INDEX_FAILURE':
    case '@taskHistory/CREATE_FAILURE':
    case '@taskHistory/UPDATE_FAILURE':
    case '@taskHistory/DELETE_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = true;
        draft.saving = false;
      });

    case '@taskHistory/READ_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = true;
        draft.registry = {};
      });

    case '@taskHistory/CLEAN':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = false;
        draft.list = [];
        draft.registry = {};
      });

    default:
      return state;
  }
}
